import View from './View';

export { default as View, getSettingsOptionPageStyles } from './View';

export default View;
